window.FoxTheme = window.FoxTheme || {};

/**
 * Resolves product image URL from JSON product data (with-metafields or products.json).
 * Prefers market gallery when market_gallery_active or metafields.markets.gallery-{handle} is set.
 */
FoxTheme.getProductImageUrl = (product) => {
  if (!product) return '';

  const marketHandle = FoxTheme.settings?.marketHandle;
  if (marketHandle) {
    const galleryKey = `gallery-${marketHandle}`;
    const marketGalleryFromMetafields = product.metafields?.markets?.[galleryKey];

    if (Array.isArray(marketGalleryFromMetafields) && marketGalleryFromMetafields.length > 0) {
      return marketGalleryFromMetafields[0];
    }

    if (product.market_gallery_active && product.images?.length > 0) {
      const firstImage = product.images[0];
      if (typeof firstImage === 'string') return firstImage;
      return firstImage?.src || firstImage?.url || firstImage?.original || '';
    }
  }

  if (product.featured_image) {
    if (typeof product.featured_image === 'string') return product.featured_image;
    return product.featured_image.src || product.featured_image.url || product.featured_image.original || '';
  }

  if (product.images?.length > 0) {
    const firstImage = product.images[0];
    if (typeof firstImage === 'string') return firstImage;
    return firstImage?.src || firstImage?.url || firstImage?.original || '';
  }

  return '';
};

/**
 * Fetches a product card HTML fragment via the section rendering API.
 */
FoxTheme.fetchProductCardHtml = async (productHandle, params = {}) => {
  if (!productHandle) return null;

  const searchParams = new URLSearchParams({
    section_id: 'product-card-render',
    image_sizes: params.image_sizes || '(max-width: 767px) calc((100vw - 30px) / 2), calc(100vw / 2)',
    image_ratio: params.image_ratio || '',
    section_index: params.section_index || '0',
    index: params.index || '1',
  });

  const marketHandle = FoxTheme.settings?.marketHandle;
  if (marketHandle) {
    searchParams.set('market_gallery_market', marketHandle);
  }

  const rootUrl = FoxTheme.routes?.root_url || '';
  const response = await fetch(`${rootUrl}/products/${productHandle}?${searchParams.toString()}`);
  if (!response.ok) return null;

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.querySelector('.f-column');
};
